import BaseModel from "./BaseModel";

export type TelawahMap = { [id: string]: string };

export default class TelawahModel extends BaseModel {
  name?: string;
  constructor(arg: any) {
    super(arg);
    this.name = arg.name;
  }

  static collectionToMap(collection: TelawahModel[]): TelawahMap {
    return collection.reduce(
      (telawahMap: TelawahMap, telawah: TelawahModel) => {
        telawahMap[`${telawah.id}`] = telawah.name!;
        return telawahMap;
      },
      {}
    );
  }
}
